import { api } from '@ohif/core';

/**
 * Get Comments
 * @param {any} projectId
 * @param {any} patientId
 * @param {any} viewer
 */
export async function getComments(projectId, patientId, viewer) {
  const path = `/comments/viewer/${projectId}/${patientId}/${viewer}`;

  try {
    const response = await api.get(path);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      return { error: 'UNAUTHORIZED' };
    }

    throw new Error(error.response?.data ? JSON.stringify(error.response.data) : error.message);
  }
}

/**
 * Add Comment
 * @param {any} projectId
 * @param {any} patientId
 * @param {any} viewer
 * @param {any} payload
 */
export async function addComment(projectId, patientId, viewer, payload) {
  const path = `/comments/viewer/${projectId}/${patientId}/${viewer}`;

  try {
    const response = await api.post(path, payload);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      return { error: 'UNAUTHORIZED' };
    }

    throw new Error(error.response?.data ? JSON.stringify(error.response.data) : error.message);
  }
}

/**
 * Delete Comment
 * @param {any} projectId
 * @param {any} patientId
 * @param {any} viewer
 * @param {any} commentId
 */
export async function deleteComment(projectId, patientId, viewer, commentId) {
  const path = `/comments/viewer/${projectId}/${patientId}/${viewer}/${commentId}`;

  try {
    const response = await api.delete(path);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      return { error: 'UNAUTHORIZED' };
    }

    throw new Error(error.response?.data ? JSON.stringify(error.response.data) : error.message);
  }
}
